import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import logo from "@/assets/cosmic-blinds-logo.png";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Blinds", path: "/blinds" },
  { label: "Areas", path: "/areas" },
  { label: "Safety", path: "/safety" },
  { label: "About", path: "/about" },
  { label: "FAQ", path: "/faq" },
  { label: "Enquiry", path: "/enquiry" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="Cosmic Blinds" className="h-12 w-auto object-contain md:h-[5.25rem]" width={126} height={84} />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors hover:text-primary ${
                location.pathname === link.path
                  ? "text-primary"
                  : "text-muted-foreground"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Button asChild size="sm" className="bg-accent text-accent-foreground hover:bg-accent/90">
            <Link to="/enquiry">
              <Phone className="mr-1 h-3.5 w-3.5" />
              Free Quote
            </Link>
          </Button>
        </nav>

        {/* Mobile menu */}
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon">
              <Menu className="h-5 w-5" />
              <span className="sr-only">Menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72">
            <SheetTitle className="font-display text-lg text-primary">Menu</SheetTitle>
            <nav className="mt-8 flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setOpen(false)}
                  className={`text-lg font-medium transition-colors hover:text-primary ${
                    location.pathname === link.path
                      ? "text-primary"
                      : "text-foreground"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="mt-6 border-t border-border pt-4 flex flex-col gap-3">
                <span className="text-xs text-muted-foreground font-medium uppercase tracking-wide">Legal</span>
                <Link to="/accessibility" onClick={() => setOpen(false)} className="text-sm text-muted-foreground hover:text-primary transition-colors">Accessibility</Link>
                <Link to="/cookies" onClick={() => setOpen(false)} className="text-sm text-muted-foreground hover:text-primary transition-colors">Cookie Policy</Link>
                <Link to="/privacy" onClick={() => setOpen(false)} className="text-sm text-muted-foreground hover:text-primary transition-colors">Privacy Policy</Link>
              </div>
              <Button asChild className="mt-4 bg-accent text-accent-foreground hover:bg-accent/90">
                <Link to="/enquiry" onClick={() => setOpen(false)}>
                  <Phone className="mr-2 h-4 w-4" />
                  Get a Free Quote
                </Link>
              </Button>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};

export default Header;
